import { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  ActionIcon,
  Badge,
  Indicator
} from '@mantine/core';
import {
  IconShoppingCart
} from '@tabler/icons-react';
import { selectCartItemCount } from '../../store/slices/cartSlice';
import CartDrawer from './CartDrawer';

const CartButton = () => {
  const [cartDrawerOpened, setCartDrawerOpened] = useState(false);
  const itemCount = useSelector(selectCartItemCount);

  const handleCartClick = () => {
    setCartDrawerOpened(true);
  };

  return (
    <>
      <Indicator
        label={itemCount}
        size={16}
        disabled={itemCount === 0}
        color="red"
        withBorder
      >
        <ActionIcon
          variant="subtle"
          size="lg"
          onClick={handleCartClick}
          title={`Shopping cart (${itemCount} items)`}
        >
          <IconShoppingCart size="1.3rem" />
        </ActionIcon>
      </Indicator>

      <CartDrawer
        opened={cartDrawerOpened}
        onClose={() => setCartDrawerOpened(false)}
      />
    </>
  );
};

export default CartButton;